export default {"src":"/blog/_next/static/media/star.3133eb92.svg","height":9,"width":9};